import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import store from "../vuex/store";
import i18n, { hasTranslation } from "@/lang/i18n";
import { isAustria } from "./Helpers";
import { getTenantId } from "./AuthService";

export default class TrackingService {
  getTracking(
    trackingNumber?: string,
    mbePackTrackingNumber?: string,
    page?: number
  ) {
    const config: AxiosRequestConfig = {
      method: "POST",
      url: store.getters.BASE_API_URL + "/shipments/tracking",
      params: {
        pageSize: 25,
        page: page ? page : 0,
        onlineTracking: false
      },
      data: {
        trackingNumber: trackingNumber,
        mbeTracking: mbePackTrackingNumber
      }
    };

    return axios.request(config).then(function(res: AxiosResponse) {
      return res.data;
    });
  }

  getTrackingUrls(
    shipmentTrackingNumber?: string,
    courierName?: string,
    zipCode?: string,
    agencyCode?: string,
    clientCode?: string
  ) {
    const config: AxiosRequestConfig = {
      method: "POST",
      url: store.getters.BASE_API_URL + "/tracking-manager/url",
      params: {
        language: store.getters["customer/config"].language.toUpperCase(),
        countryId:
          store.getters["customer/storeInfo"].storeAddresses[0].countryId,
        mbeTrackingUrl: false,
        agencyCode: agencyCode,
        clientCode: clientCode
      },
      data: {
        courierName: courierName,
        shipmentTrackingNumber: shipmentTrackingNumber,
        countryId:
          store.getters["customer/storeInfo"].storeAddresses[0].countryId,
        tenantId: getTenantId(),
        addressTo: {
          zipCode: zipCode
        }
      }
    };

    return axios.request(config).then(function(res: AxiosResponse) {
      return res.data;
    });
  }

  getTrackingMBEURL(mbeTrackingNumber: string, tenantLang: string) {
    let base = "https://www.mbe.{0}/{0}/tracking?c={1}";
    if (tenantLang.toLowerCase() === "fr") {
      base = "https://www.mbefrance.{0}/{0}/tracking?c={1}";
    }
    if (tenantLang.toLowerCase() === "uk") {
      base = "https://www.mbe.co.{0}/track?tracking={1}";
    }
    return base
      .replace("{0}", tenantLang)
      .replace("{0}", tenantLang)
      .replace("{1}", mbeTrackingNumber);
  }
  isTNTInternational(courierName: string, shipmentType: any): boolean {
    const courierParam = courierName.toUpperCase();
    return courierParam === "TNT" && shipmentType !== "DOMESTIC";
  }
  getCourierTrackinUrls(shipments: any[]): string[] {
    const urlsArray: any[] = shipments
      .filter((el: any) => {
        return el["shipmentTrackingNumber"]; // only shipments with tracking
      })
      .filter((el: any) => {
        return el["shipmentTrackingNumber"] !== el["mbeTracking"]; // only shipments with real courier tracking
      })
      .map((el: any) => {
        let courierParam = el["courierName"].toUpperCase();

        if (courierParam === "GEL") {
          if (el.courierServiceId === 9602) {
            courierParam = "TNT";
          } else {
            courierParam = "POSTE";
          }
        }
        const shipReceiverZipCode = el.addressTo.zipCode;

        if (
          this.isTNTInternational(
            courierParam,
            el["shipmentType"] ? el["shipmentType"] : "DOMESTIC"
          )
        ) {
          courierParam = "TNT_INT";
        }
        if (isAustria()) {
          courierParam += "_AT";
        }

        let shipTrackings = [el["shipmentTrackingNumber"]];
        //FOR IDS
        const key = "tracking_url_" + courierParam;
        if (hasTranslation(key)) {
          const countryId = "de";

          if (courierParam === "DPD_PL") {
            shipTrackings = [];
            el.shipmentPackages.forEach((element: any) => {
              shipTrackings.push(element.waybillNumber);
            });
          }

          const urlsArray: any[] = [];
          shipTrackings.forEach(shipTracking => {
            const trackingURL = i18n.t(key, {
              "0": shipTracking,
              "1": store.getters.language + "_" + countryId,
              "2": countryId,
              "8": shipReceiverZipCode
            });
            urlsArray.push(trackingURL);
          });

          return urlsArray;
        } else {
          console.error(
            "no i18n key for courier tracking: " +
              key +
              " please configure a public url for this courier"
          );
          return undefined;
        }
      })
      .filter(value => value); //filter undefined
    const urls: any[] = [];
    urlsArray.forEach(item => {
      if (item != undefined) {
        item.forEach((url: any) => {
          if (url != undefined) urls.push(url);
        });
      }
    });
    return Array.from(new Set(urls)); // deduplicate urls using set
  }
}
